import React from 'react';
import MediaQuery from "react-responsive";
import SidebarDesktop from "components/sidebar/SidebarDesktop";
import SidebarMobile from "components/sidebar/SidebarMobile";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import getToastTransition from "components/pageForm/toastTransition";

const Intercom = () => {
  return (
    <>
      <div className="flex h-screen overflow-y-hidden tab:overflow-hidden">
          {/* Sidebar - rendue sur tous les écrans */}
          <SidebarDesktop/>
          {/* Navbar mobile - uniquement sur mobile */}
          <MediaQuery maxWidth={768}><SidebarMobile/></MediaQuery>
          {/* Content area */}
          <div className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
              <main className={'w-full h-full flex flex-col overflow-y-auto'}>
                  <div className="flex flex-col w-full h-full bg-white">
                      <div className="w-full h-full">
                          <iframe
                              src="https://app.intercom.com/"
                              className="w-full h-full border-0"
                              title="Intercom"
                              allow="fullscreen"
                          />
                      </div>
                  </div>
              </main>
          </div>
      </div>
      <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          limit={2}
          pauseOnFocusLoss
          draggable
          transition={getToastTransition()}
      />
    </>
  );
};

export default Intercom;

